import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {observer} from "mobx-react"
import BienStore from "../BienStore"
import axios from "axios"

@observer
class DonneesImmeubles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typesdebiens: [],
      loaded: true,
      doublecompteurs: false
    };
  }
  componentDidMount(){
  }
  showNextBTN(){
    if(BienStore.checkBienElements ){
        BienStore.saveState()
        return <p><Link className="btn btn-large wave" to="/Pieces">Suivant</Link></p>
      }else{
        return <p><Link className="btn btn-large wave disabled" to="/" >Suivant</Link></p>

      }
  }
  render () {

    return (
      <React.Fragment>
      <h2 className="center">Données de bases</h2>
      <div>
      <div className="container">
        <div className="row">
          <div className="input-field col s6">
            <p className="">Compteur eau chaude froide sépare </p>
              <div className="switch">
                <label>
                  Non
                  <input type="checkbox"  defaultChecked={BienStore.elements["eauchaudfroidsepare"]} onChange={(e) => BienStore.elements["eauchaudfroidsepare"] = !BienStore.elements["eauchaudfroidsepare"]}/>
                  <span className="lever"></span>
                  Oui
                </label>
              </div>
          </div>
            {BienStore.elements["eauchaudfroidsepare"] ? (
              <div className="col s6">
                <p>Veuillez entrez le numéro du compteur d'eau froide et celui d'eau chaude</p>
                <div className="input-field">
                  <input type="text" id="froid" value={BienStore.elements["compteureaufroide"]} onChange={(e) => BienStore.elements["compteureaufroide"] = e.target.value}/>
                  <label htmlFor="froid">Compteur eau froide</label>
                </div>
                <div className="input-field">
                  <input type="text" id="chaud" value={BienStore.elements["compteureauchaude"]} onChange={(e) => BienStore.elements["compteureauchaude"] = e.target.value}/>
                  <label htmlFor="chaud">Compteur eau chaude</label>
                </div>
              </div>
              ) : (
              <div className="col s6">
                <p>Veuillez entrez le numéro du compteur d'eau </p>
                <div className="input-field">
                  <input type="text" id="eau" value={BienStore.elements["compteureau"]} onChange={(e) => BienStore.elements["compteureau"] = e.target.value}/>
                  <label htmlFor="eau">Compteur eau</label>
                </div>
              </div>
              )}



        </div>
        <div className="row">
          <div className="input-field col s6">
            <p className="">Du Gaz ?</p>
              <div className="switch">
                <label>
                  Non
                  <input type="checkbox"  defaultChecked={BienStore.elements["gaz"]} onChange={(e) => BienStore.elements["gaz"] = !BienStore.elements["gaz"]}/>
                  <span className="lever"></span>
                  Oui
                </label>
              </div>
          </div>
            {BienStore.elements["gaz"] ? (
              <div className="col s6">
                <p>Veuillez entrez le numéro du compteur de gaz</p>
                <div className="input-field">
                  <input type="text" id="gaz" value={BienStore.elements["compteurgaz"]} onChange={(e) => BienStore.elements["compteurgaz"] = e.target.value}/>
                  <label htmlFor="gaz">Compteur gaz</label>
                </div>
              </div>
              ) : (
              <div className="col s6">
                <p>Vous n'avez vraiment pas de gaz dans le bien, c'est désolant ! </p>
              </div>
              )}



        </div>
        <div className="row">
          <div className="input-field col s6">
            <p className="">De l'électricité ?</p>
              <div className="switch">
                <label>
                  Non
                  <input type="checkbox"  defaultChecked={BienStore.elements["electricite"]} onChange={(e) => BienStore.elements["electricite"] = !BienStore.elements["electricite"]}/>
                  <span className="lever"></span>
                  Oui
                </label>
              </div>
          </div>
            {BienStore.elements["electricite"] ? (
              <div className="col s6">
                <p>Veuillez entrez le numéro du compteur d'électricité'</p>
                <div className="input-field">
                  <input type="text" id="electricite" value={BienStore.elements["compteurelectricite"]} onChange={(e) => BienStore.elements["compteurelectricite"] = e.target.value}/>
                  <label htmlFor="electricite">Compteur électricité</label>
                </div>
              </div>
              ) : (
              <div className="col s6">
                <p>Est-ce un bien pour homme des cavernes ? </p>
              </div>
              )}



        </div>
        <div className="row">
          <div className="input-field col s6">
            <p className="">le batiment à </p>
              <div className="switch">
                <label>
                  Moins de 10ans
                  <input type="checkbox" defaultChecked={BienStore.elements["plusde10ans"]} onChange={(e) => BienStore.elements["plusde10ans"] = !BienStore.elements["plusde10ans"]}/>
                  <span className="lever"></span>
                  plus de 10ans
                </label>
              </div>
          </div>
          <div className="input-field col s6">
            <p className="">le bien est meublé ? </p>
              <div className="switch">
                <label>
                  Non vide
                  <input type="checkbox"  defaultChecked={BienStore.elements["meuble"]} onChange={(e) => BienStore.elements["meuble"] = !BienStore.elements["meuble"]}/>
                  <span className="lever"></span>
                  oui meublés
                </label>
              </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col s4 offset-s8">
          {this.showNextBTN()}
          </div>
          </div>
        </div>

      </React.Fragment>
    );
  }
}

export default DonneesImmeubles
